import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { useNavigationHistoryStore } from '@/stores/navigation-history.store';
import { matchRoutePattern } from '@/lib/route-config';

export function useNavigationHistory(): void {
    const location = useLocation();
    const navigationType = useNavigationType();
    const navigate = useNavigationHistoryStore((state) => state.navigate);
    const syncWithBrowser = useNavigationHistoryStore(
        (state) => state.syncWithBrowser,
    );
    const lastProcessedKey = useRef<string | null>(null);
    const hasSyncedOnMount = useRef(false);

    useEffect(() => {
        if (!hasSyncedOnMount.current) {
            hasSyncedOnMount.current = true;
            const fullPath =
                location.pathname + location.search + location.hash;
            syncWithBrowser(fullPath);
        }
    }, [location.pathname, location.search, location.hash, syncWithBrowser]);

    useEffect(() => {
        const locationKey =
            location.key ?? location.pathname + location.search + location.hash;

        if (lastProcessedKey.current === locationKey) {
            return;
        }

        lastProcessedKey.current = locationKey;
        const fullPath = location.pathname + location.search + location.hash;
        const route = matchRoutePattern(location.pathname);

        navigate({ path: fullPath, route }, navigationType);
    }, [
        location.key,
        location.pathname,
        location.search,
        location.hash,
        navigationType,
        navigate,
    ]);
}
